import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Col, Image, Row } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { getServiceRequest } from "../../../../commons/ServiceRequest";
import { compareDateTimes, formatInputDate } from "../../../../utils/Time";
import {
  FloatingControlComponent,
  FormCheckComponent
} from "../../../../components/FormComponent";
import {
  filteredItemBySearch,
  filteredItemInRange,
  findItemInArray
} from "../../../../utils/ManageArray";
import {
  autoDisplayValue,
  formatCurrency,
  formatSplitKey,
  plusStringValue
} from "../../../../commons/FormatValue";
import {
  AttachFileIcon,
  DeleteIcon,
  GooglePinIcon,
  PreviewIcon
} from "../../../../data/iconImage";
import Table from "../../../../components/Table";
import ButtonLink from "../../../../components/ButtonLink";
import SearchFilter from "../../../../components/SearchFilter";
import PaginationComponent from "../../../../components/PaginationComponent";
import CardDisplayComponent from "../../../../components/CardDisplayComponent";
import SeqOthersJobsService from "../../../../services/seqothersjob.service";
import CustContractItemsService from "../../../../services/custcontractitem.service";

export default function WorkOrders() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation();
  const { loading, setLoading } = useLoading();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState({ Seq: [], Work: [{}] });
  const [CustContractItems, setCustContractItems] = useState([]);
  const searchInput = [
    {
      name: "createdAt",
      type: "date",
      label: "วันที่สร้างใบสั่งงาน"
    },
    {
      name: "Seq_Oth_No",
      label: "เลขที่ใบสั่งงาน",
      filterBy: ["Seq_Oth_No"],
      value: findItemInArray(data?.Seq, "Id", state?.Seq_Other_Id)?.Seq_Oth_No
    },
    {
      name: "InformOtherJob.JobType.Job_Type_Name",
      label: "ประเภทงาน",
      size: null,
      minKeywordLength: 1
    },
    {
      name: "InformOtherJob.JobTypeSub.Job_Type_Sub_Name",
      label: "ประเภทงานย่อย",
      size: null,
      minKeywordLength: 1
    }
  ];
  const rowData = data?.Work?.[currentPage - 1];
  const inputField = {
    Inform: [
      {
        name: "Seq_Oth_No",
        label: "เลขที่ใบสั่งงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.JobType.Job_Type_Name",
        label: "ประเภทงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "InformOtherJob.JobTypeSub.Job_Type_Sub_Name",
        label: "ประเภทงานย่อย",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "InformOtherJob.Ref_Doc_No",
        label: "อ้างอิงหมายเลขแจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Inform_Doc_Date",
        label: "วันที่แจ้งงาน",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: "1_75",
        format: (row) => formatInputDate(row, "Local")?.date
      },
      {
        name: "InformOtherJob.Inform_Doc_Date",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_25",
        format: (row) => formatInputDate(row, "Local")?.time
      },
      {
        name: "InformOtherJob.Customer.Cus_Code",
        label: "รหัสลูกค้าหลัก (BP Master Code)",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Customer.Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Project_No",
        label: "หมายเลขโครงการ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "InformOtherJob.Service_Call",
        label: "Call No.",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "InformOtherJob.Job_Cus_Date",
        label: "วันที่นัดหมายลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        size: "1_75",
        format: (row) => formatInputDate(row, "Local")?.date
      },
      {
        name: "InformOtherJob.Job_Cus_Date",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "time",
        size: "1_25",
        format: (row) => formatInputDate(row, "Local")?.time
      },
      {
        name: "InformOtherJob.Customer.Cus_Address",
        label: "ที่อยู่",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9
      },
      {
        name: "InformOtherJob.Cus_Contract_Tel1",
        label: "เบอร์โทรผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.BPCustomer.Cus_Code",
        label: "รหัสสาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "2_25"
      },
      {
        name: "InformOtherJob.BPCustomer.Cus_NumBranch",
        label: "เลขที่สาขา",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "1_5"
      },
      {
        name: "InformOtherJob.BPCustomer.Cus_Name",
        label: "ชื่อลูกค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "5_25"
      },
      {
        name: "InformOtherJob.Cus_Contract_Tel2",
        label: "เบอร์โทรผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.BPCustomer.Cus_Address",
        label: "สถานที่จัดส่งสินค้า",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 9
      },
      {
        name: "InformOtherJob.Cus_Contract_Name1",
        label: "ผู้ติดต่อ 1",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.BPCustomer.Cus_ContactEmail",
        label: "Email",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Attach_File",
        label: "ไฟล์แนบ( PDF )",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "4_25"
      },
      {
        name: "PreviewIcon",
        type: "button",
        classNames: { col: "d-flex align-items-center mb-3" },
        size: "0_67",
        img: { src: PreviewIcon, alt: "Preview Icon" }
      },
      {
        name: "DeleteIcon",
        type: "button",
        classNames: { col: "d-flex align-items-center mb-3" },
        size: "0_67",
        img: { src: DeleteIcon, alt: "Delete Icon" }
      },
      {
        name: "AttachFileIcon",
        type: "button",
        classNames: { col: "d-flex align-items-center mb-3" },
        size: "0_67",
        img: { src: AttachFileIcon, alt: "AttachFile Icon" }
      },
      {
        name: "InformOtherJob.Cus_Contract_Name2",
        label: "ผู้ติดต่อ 2",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.GoogleMap_Link",
        label: "Google Map",
        classNames: { col: "mb-3", label: "mb-1" },
        size: "8_33"
      },
      {
        name: "GooglePinIcon",
        type: "button",
        classNames: { col: "d-flex align-items-center mb-3" },
        size: "0_67",
        img: { src: GooglePinIcon, alt: "Pin Icon" }
      },
      {
        name: "SequneceStatus.Seq_St_Name",
        label: "สถานะใบสั่งงาน",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Job_Name",
        label: "ชื่องาน",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "InformOtherJob.To_Section",
        label: "ถึงแผนก",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Sub_Team",
        label: "ชื่อทีม/หัวหน้าช่าง",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.Subject_Inform",
        label: "เรื่องที่แจ้ง",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      },
      {
        name: "InformOtherJob.Remark",
        label: "หมายเหตุ",
        classNames: { col: "mb-3", label: "mb-1" },
        size: 6
      }
    ],
    Additional: {
      name: "InformOtherJob.Cus_Cpec_Tex",
      label: "คำสั่งเพิ่มเติม (ลูกค้า)"
    },
    PreventiveRadio: [
      { name: "InformOtherJob.PM_List", label: "มี PM" },
      { name: "InformOtherJob.PM_List", label: "ไม่มี PM" },
      { name: "InformOtherJob.PM_List", label: "รอสรุป" }
    ],
    PreventiveInput: [
      {
        name: "InformOtherJob.Contract_No",
        label: "เลขที่สัญญา",
        classNames: { col: "mb-3", label: "mb-1" }
      },
      {
        name: "InformOtherJob.CustContract.Contract_Start_Date",
        label: "วันที่เริ่มต้นสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        format: (row) => formatInputDate(row, "Local")?.date
      },
      {
        name: "InformOtherJob.CustContract.Contract_End_Date",
        label: "วันที่สิ้นสุดสัญญา",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "date",
        format: (row) => formatInputDate(row, "Local")?.date
      },
      {
        name: "PM_Per_Year",
        label: "จำนวน PM/ปี",
        findValue: {
          CustContractItems,
          key: "Contract_No",
          value: "PM_Per_Year"
        }
      },
      {
        name: "InformOtherJob.Inform_By_Id",
        label: "ผู้แจ้ง",
        plusValue: [
          "InformOtherJob.InformEmployee.Employee_Name",
          "InformOtherJob.InformEmployee.Employee_Surname"
        ]
      },
      { name: "InformOtherJob.Inform_Section", label: "แผนกที่แจ้ง" }
    ],
    WorkDetails: [
      {
        name: "InformOtherJob.JobList1",
        label: "สำรวจหน้างาน",
        classNames: {
          col: "mb-3 w-auto",
          check: "d-flex align-items-center",
          label: "mb-1"
        }
      },
      {
        name: "InformOtherJob.JobList2",
        label: "งานรื้อถอน",
        classNames: {
          col: "mb-3 w-auto",
          check: "d-flex align-items-center",
          label: "mb-1"
        }
      },
      {
        name: "InformOtherJob.JobList3",
        label: "ติดตั้ง",
        classNames: {
          col: "mb-3 w-auto",
          check: "d-flex align-items-center",
          label: "mb-1"
        }
      },
      {
        name: "InformOtherJob.JobList4",
        label: "เทสระบบ",
        classNames: { col: "w-auto", check: "d-flex align-items-center" }
      },
      {
        name: "InformOtherJob.JobList5",
        label: "Training/ส่งมอบ",
        classNames: { col: "w-auto", check: "d-flex align-items-center" }
      },
      {
        name: "InformOtherJob.JobList6",
        label: "เก็บน้ำ",
        classNames: { col: "w-auto", check: "d-flex align-items-center" }
      }
    ]
  };
  const columns = {
    Item: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รหัสสินค้า/อุปกรณ์",
        selector: (row) => row.Item?.Item_Code,
        minWidth: "280px"
      },
      {
        name: "รายละเอียดสินค้า/อะไหล่/อุปกรณ์",
        selector: (row) => row.Item?.Item_Name_TH,
        minWidth: "350px"
      },
      {
        name: "จำนวน",
        selector: (row) => row.Item_Install_Qty,
        format: (row) => formatCurrency(row.Item_Install_Qty || ""),
        minWidth: "120px"
      },
      { name: "หน่วย", selector: (row) => row.Uom_Unit, minWidth: "120px" },
      {
        name: "ราคา",
        selector: (row) => row.Item_Price_Per_Unit,
        format: (row) => formatCurrency(row.Item_Price_Per_Unit || ""),
        minWidth: "120px"
      },
      {
        name: "ราคารวม",
        selector: (row) => row.Item_Amount,
        format: (row) => formatCurrency(row.Item_Amount || ""),
        minWidth: "120px"
      },
      {
        name: "สกุลเงิน",
        selector: (row) => row.Item_Price_Unit,
        minWidth: "120px"
      }
    ],
    Job: [
      {
        name: "ลำดับ",
        selector: (row) => row.rowIndex,
        sortable: true,
        width: "110px"
      },
      {
        name: "รายการค่าบริการ",
        selector: (row) => row.Oth_Des,
        minWidth: "300px"
      },
      {
        name: "ราคา",
        selector: (row) => row.Oth_Price,
        format: (row) => formatCurrency(row.Oth_Price || ""),
        minWidth: "120px"
      },
      {
        name: "สกุลเงิน",
        selector: (row) => row.Oth_Price_Unit,
        minWidth: "120px"
      },
      { name: "หมายเหตุ", selector: (row) => row.Remark, minWidth: "350px" }
    ]
  };

  const handleSearchFilter = (search) => {
    const hasValue = search.some(({ value }) => value);
    if (!hasValue)
      navigate("/general_job/create", {
        state: { ...state, Seq_Other_Id: null }
      });

    const [start, end] = search.filter(
      ({ name, type }) =>
        type === "date" && ["createdAt"].some((suffix) => name.includes(suffix))
    );
    const filteredData = filteredItemInRange(
      data?.Seq,
      search,
      start?.name,
      end?.name
    ).filter((item) =>
      search
        .filter(({ value }) => value)
        .every((search) => compareDateTimes(item, search, start, end))
    );
    setData((prev) => ({ ...prev, Work: hasValue ? filteredData : [{}] }));
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: SeqOthersJobsService.getAllSeqOthersJobs(),
      callback: (res) => setData((prev) => ({ ...prev, Seq: res }))
    });

    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: CustContractItemsService.getCustContractItems(
        `?keyword=${rowData?.InformOtherJob?.Contract_No}`
      ),
      callback: ({ items }) => {
        setCustContractItems(
          findItemInArray(
            items,
            "Contract_No",
            rowData?.InformOtherJob?.Contract_No
          )
        );
      }
    });
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: { className: "text-center", text: "ข้อมูลใบสั่งงาน" }
        }}
        body={{
          element: (
            <SearchFilter
              data={data?.Seq}
              inputField={searchInput}
              fieldClassName={{ actionButton: "w-auto" }}
              searchBtnOnClick={searchInput.some(({ value }) => value)}
              searchCallback={handleSearchFilter}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{
          title: { text: "รายละเอียดใบสั่งงาน" },
          className: "d-flex justify-content-between align-items-center",
          button: (
            <ButtonLink
              linkTo="edit"
              stateData={{ name: "issue" }}
              buttonClass="mb-1 px-5 py-2 rounded-pill"
              buttonName="แก้ไขสถานะใบสั่งงาน"
            />
          )
        }}
        body={{
          as: Row,
          element: inputField?.Inform.map(
            (
              {
                name,
                label,
                type,
                size,
                classNames,
                img,
                format,
                findValue,
                plusValue
              },
              idx
            ) => {
              const value =
                (findValue &&
                  autoDisplayValue({
                    name,
                    type,
                    findValue: {
                      ...findValue,
                      value: rowData?.[findValue?.value]
                    }
                  })) ||
                (format && format(formatSplitKey(name, ".", rowData))) ||
                (plusValue && plusStringValue(plusValue, " ", rowData)) ||
                formatSplitKey(name, ".", rowData);

              return (
                <Col
                  key={idx}
                  sm={size === null ? null : size || 3}
                  className={classNames?.col}
                >
                  {type === "button" ? (
                    <Button
                      disabled
                      variant="light"
                      className="px-1 border rounded-circle"
                      style={{
                        filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))"
                      }}
                    >
                      <Image height="24" src={img?.src} alt={img?.alt} />
                    </Button>
                  ) : (
                    <FloatingControlComponent
                      disabled
                      type={type}
                      name={name}
                      label={label}
                      className={classNames}
                      value={value}
                    />
                  )}
                </Col>
              );
            }
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดสินค้า/อุปกรณ์" } }}
        body={{
          element: (
            <Table
              data={rowData?.InformOtherJob?.ItemOther || []}
              column={columns?.Item}
              pending={loading}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดค่าบริการ" } }}
        body={{
          element: (
            <Table
              data={rowData?.InformOtherJob?.JobOtherPrice || []}
              column={columns?.Job}
              pending={loading}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          element: (
            <FloatingControlComponent
              disabled
              type="text"
              name={inputField?.Additional?.name}
              label={inputField?.Additional?.label}
              value={formatSplitKey(inputField?.Additional?.name, ".", rowData)}
            />
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "Preventive Maintenance" } }}
        body={{
          element: (
            <>
              <Row>
                {inputField?.PreventiveRadio.map(
                  ({ name, label, classNames }, idx) => (
                    <Col key={idx} sm={1} className="mb-3 w-auto">
                      <FormCheckComponent
                        readOnly
                        id={name}
                        type="radio"
                        label={label}
                        name="PreventiveInput"
                        className={classNames}
                        checked={formatSplitKey(name, ".", rowData) === label}
                      />
                    </Col>
                  )
                )}
              </Row>
              <Row>
                {inputField?.PreventiveInput.map(
                  (
                    {
                      name,
                      label,
                      classNames,
                      type,
                      findValue,
                      plusValue,
                      format
                    },
                    idx
                  ) => {
                    const value =
                      (format && format(formatSplitKey(name, ".", rowData))) ||
                      (plusValue && plusStringValue(plusValue, " ", rowData)) ||
                      formatSplitKey(name, ".", rowData);
                    return (
                      <Col key={idx} sm={4} className={classNames?.col}>
                        <FloatingControlComponent
                          disabled
                          type={type}
                          name={name}
                          label={label}
                          className={classNames}
                          value={
                            (findValue &&
                              CustContractItems?.[findValue?.value]) ||
                            value
                          }
                        />
                      </Col>
                    );
                  }
                )}
              </Row>
            </>
          )
        }}
      />

      <CardDisplayComponent
        header={{ title: { text: "รายละเอียดการทำงาน" } }}
        body={{
          as: Row,
          element: inputField?.WorkDetails.map(
            ({ name, label, classNames }, idx) => (
              <Col key={idx} sm={1} className={classNames?.col}>
                <FormCheckComponent
                  readOnly
                  id={name}
                  type="checkbox"
                  label={label}
                  name="WorkDetails"
                  className={classNames}
                  checked={!!formatSplitKey(name, ".", rowData)}
                />
              </Col>
            )
          )
        }}
      />

      <CardDisplayComponent
        body={{
          element: (
            <PaginationComponent
              data={data?.Work}
              currentPage={currentPage}
              itemsPerPage={1}
              onPageChange={(newPage) => setCurrentPage(newPage)}
            />
          )
        }}
      />

      <CardDisplayComponent
        body={{
          as: Row,
          className: "justify-content-center",
          element: (
            <Col sm={3} className="w-auto">
              <ButtonLink
                linkTo="preview"
                stateData={{
                  name: "issue",
                  type: "workorder",
                  Work: data?.Work
                }}
                buttonName="แสดงใบสั่งงาน"
                buttonColor="success"
                buttonClass="px-5 py-2 border-opacity-50 rounded-pill"
              />
              <Button
                variant="outline-secondary"
                className="w-auto ms-2 px-5 text-dark rounded-pill"
                onClick={() =>
                  navigate("/general_job/create", { state: { name: "issue" } })
                }
              >
                ย้อนกลับ
              </Button>
            </Col>
          )
        }}
      />
    </>
  );
}
